export const ARIA_ROLES = {
  BUTTON: 'button',
} as const;

export const KEYBOARD_KEYS = {
  ENTER: 'Enter',
  ESCAPE: 'Escape',
} as const;

export const HTML_BUTTON_TYPES = {
  BUTTON: 'button',
  SUBMIT: 'submit',
  RESET: 'reset',
} as const;
